require('./contractEasyLoanStep3.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// Commons components
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ CC Components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @Components
const ContractLoanPdfViewerError = require('../../contractLoanPdfViewerError/contractLoanPdfViewerError');

// @constants
const {
    VIEWER_HEIGHT_INE_PDF,
    INE_DOCUMENT_NAME
} = require('../../../../loansConstants/index');
const translationContractLoanPdfViewerINE = require("../../contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations")
const { NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES,EVIDENCE_EASY_LOAN } = require('constants/flagBasedFeatures');

//@utilities
const download = require('downloadjs');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

class ContractEasyLoanStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {isPdfReeded: false, agreeCheckModal: false, confirmed: false };
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this); 
        this.handleAgreeCheckModal = this.handleAgreeCheckModal.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
    }

    handleAgreeCheckModal() {
        this.props.toggleINEAgreeCheckbox()
    }

    handleDocumentReaded() {
        this.setState({ isPdfReeded: true });
    }

    handleOnDownloadDocument() {
        const { immContractEasyLoan } = this.props;
        let documentName = '';
        let document;  
        document = immContractEasyLoan.get('fileEasyLoanIneDocument');
        documentName = INE_DOCUMENT_NAME;
        download(document, documentName, 'application/pdf');
    }

    handleOnPrintDocument() {
        const { immContractEasyLoan, setOfficeStep, immFlagBasedFeatures } = this.props;
        const document = immContractEasyLoan.get('fileEasyLoanIneDocument');
        if(document){
            openBase64pdfInPrintWindow(document);
            isPrintOfficeMode() && immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && setOfficeStep("INE");
        }     
    }

    buildCheckbox() {
        const {
            validate,
            immContractEasyLoan
        } = this.props;
        const { isPdfReeded } = this.state;
        const checkboxFlag= immContractEasyLoan.get('checkboxFlag');
        const errorLoading = immContractEasyLoan.get('errorEasyLoanIneDocument') || !isPdfReeded;
        const agreeIneCheckbox = immContractEasyLoan.get('agreeIneCheckbox')
        const errorState = (validate && !agreeIneCheckbox);
        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage'); 
        const checkbox = (
            <div>
                <OKCheckbox
                    extraClass="contract-loan-pdf-viewer__checkbox"
                    disabled={checkboxFlag}
                    errorMessage={errorMessage}
                    errorState={errorState}
                    idName="contract-loan-pdf-viewer-checkbox"
                    label={<FormattedText value={translationContractLoanPdfViewerINE.PDF_CHECKBOX} />}
                    onChange={this.handleAgreeCheckModal}
                    value={agreeIneCheckbox || checkboxFlag}
                    />
            </div>
        ) 

        return !errorLoading || checkboxFlag ? checkbox : null;
    }

    buildViewer() {
        const { immContractEasyLoan, scale, getINEDocument, getLoanContractDocuments, immFlagBasedFeatures } = this.props;
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
        const evidenceFF = immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN);
        const fileINEDocument = immContractEasyLoan.get('fileEasyLoanIneDocument');
        const errorINEDocument = immContractEasyLoan.get('errorEasyLoanIneDocument');
        const isFetchingINEDocument = immContractEasyLoan.get('isFetchingINEDocument');
        const fetchingProposition = immContractEasyLoan.get('fetchingProposition');
        const operationProcessId = immContractEasyLoan.get('operationProcessIdINE');

        if (isFetchingINEDocument || fetchingProposition) {
            return <LoadingSection />;
        }

        return(
            <OKPdfViewer
                onDownload={this.handleOnDownloadDocument}
                title={isPrintOfficeMode() && newEasyLoanFF ?
                    <FormattedText value="contractsView-precontractualConditionsOfficeTitle" />:
                    <FormattedText value="contractEasyLoanStepThree-easyLoanStepThreeINEVisorTitle" />
                    }
                onPrint={this.handleOnPrintDocument}
                pdfFile={fileINEDocument}
                displayScrollButton
                scale={scale}
                infiniteScroll={false}
                failedLoadingPdf={errorINEDocument}
                errorComponent={() => {
                    return <ContractLoanPdfViewerError getDocuments={newEasyLoanFF && evidenceFF ? getLoanContractDocuments:getINEDocument} operationProcessId={operationProcessId}/>
                }}
                viewerHeight={VIEWER_HEIGHT_INE_PDF}
                onDocumentReaded={this.handleDocumentReaded}
            />
        )
    }

    ineBlockTitle() {
        return (
        <BlockInfo>
            <FormattedText value={"contractEasyLoanStepThree-ineBlockTitle"} />
        </BlockInfo>)
    }

    render() {
        const { immFlagBasedFeatures } = this.props;
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
        const checkbox = (isPrintOfficeMode() && !newEasyLoanFF) || !__CONTACT_CENTER__ && this.buildCheckbox();
        const viewer = this.buildViewer();
        const ineBlockTitle = isPrintOfficeMode() && newEasyLoanFF && this.ineBlockTitle();

        return (
            <section className="contract-easy-loan-document-step">
                <div className="contract-easy-loan-document-step__title">
                    {isPrintOfficeMode() && newEasyLoanFF ?
                    <FormattedText value="contractsView-precontractualConditionsOfficeTitle" />:
                    <FormattedText value="contractEasyLoanStepThree-easyLoanStepThreeTitle" />
                    }
                </div>
                <div className="modal-container contract-easy-loan-document-step__pdfcontent">
                    <div className="contract-easy-loan-document-step__informative-text">
                    {isPrintOfficeMode() && newEasyLoanFF ?
                        <FormattedText value="preContractDocument-preContractDocument_precontractualConditionsPdfOfficeTitle" />:
                        <FormattedText value="contractEasyLoanStepThree-easyLoanStepThreeSubTitle" />
                    }
                    </div>
                    {ineBlockTitle}
                    {viewer}
                </div> 
                {checkbox}            
            </section>
        );
    }
}

ContractEasyLoanStep3.propTypes = {
    beforeStep: PropTypes.number.isRequired,
    errorAsnef: PropTypes.bool,
    immContractEasyLoan: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    toggleINEAgreeCheckbox :PropTypes.func.isRequired,
    validate: PropTypes.bool,
    scale: PropTypes.number,
    setOfficeStep:PropTypes.func,
    getLoanContractDocuments: PropTypes.func
};

ContractEasyLoanStep3.defaultProps = {
    scale: 1,
};

module.exports = ContractEasyLoanStep3;
